import { render } from "./CRMAgentGeneralSettingsComponent.vue?vue&type=template&id=42428d87"
import script from "./CRMAgentGeneralSettingsComponent.vue?vue&type=script&lang=js"
export * from "./CRMAgentGeneralSettingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__